/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Grid, Stack, Switch, Modal, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useFieldArray, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import CustomSelect from "../../../components/forms/select/CustomSelect";
import { ControlledInput } from "../../../components/forms/input/ControlledInput";
import FileUpload from "../../../components/forms/fileInput/FileUpload";
import { endpoints } from "../../../api/endpoints";
import { useCrudForm } from "../../../api/useCrudForm";
import { FooterInfo } from "./NewCustomerForm";
import { AccountTypes, DocumentTypes, LockerStatus } from "../CustomerConstants";
import { ControlledTextArea } from "../../../components/forms/input/ControlledTextArea";
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CameraCapture from "../../../components/webCam/CaptureImage";
import { toast } from "react-toastify";
import { Search, Refresh, Edit } from "@mui/icons-material";
import { TableHeadCell } from "../../../components/styledComponent/table/TableCell";
import CustomerLockerReleaseForm from "./CustomerLockerReleaseForm";
import AddEditModal from "../../../components/modal/Modal";
import { SaveStyle } from "../../../components/modal/modalBoxStyle";

const DetailsForm = ({ isJoint, setPage, selectedCustomer, isAttorney, fetchData }: { isJoint: any, setPage: (value: any) => void, selectedCustomer: any, isAttorney?: boolean, fetchData: any }) => {

    const { handleSubmit, control, formState: { errors, }, watch, setValue, getValues } = useForm<valuesTypes>(
        {
            resolver: yupResolver(customerRegisterValidation),
            defaultValues: selectedCustomer ?? { ...initialValues, accountType: isAttorney ? 2 : isJoint ? 1 : 0 }
        }
    )

    const { fields, append, remove, update } = useFieldArray({
        control,
        name: "customerLockers"
    });

    const [submitting, setIsSubmitting] = useState<any | null>()

    const [imageUrl, setImageUrl] = useState<any | null>()
    const [isData, setIsData] = useState<any | null>(selectedCustomer ? true : false)
    const [isLoading, setIsLoading] = useState<any | null>(false)
    const [profileImageUrl, setProfileImageUrl] = useState<any>()
    const [lockerType, setLockerType] = useState([])
    const [confirmEdit, setConfirmEdit] = useState(false)
    const [confirmDialog, setConfirmDialog] = useState(false)

    const { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isMainTable = queryParams.get('isMainTable') ?? 'false'

    const { add, edit, get } = useCrudForm()
    const watchAccountDocumentType: any = watch("docType")
    const watchAccountNumber: any = watch("accountNumber")
    const watchIsStaff: any = watch("isStaff")

    useEffect(() => {
        get({
            endpoints: endpoints.common.getLockerTypes,
            onSuccess: (data: any) => {
                setLockerType(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }, [])

    useEffect(() => {
        if (selectedCustomer?.customerInformation?.docPhotoUrl) {
            setImageUrl(selectedCustomer?.customerInformation?.docPhotoUrl)
        }
    }, [selectedCustomer?.customerInformation?.docPhotoUrl])

    const formData = getValues()

    const onSubmit = (values: any) => {
        setIsSubmitting(true)
        if (selectedCustomer && id) {
            edit({
                endpoints: `${endpoints.customer.edit}?isMainTable=${isMainTable}`,
                onSuccess: (data: any) => {
                    setPage('two')
                    fetchData()
                    setIsSubmitting(false)
                    toast.success(data.message, { style: { background: '#3150A1' } })
                    navigate(`/customers/new-registration/${data.data}?isMainTable=false`)
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                    setIsSubmitting(false)
                },
                values: values
            })
        } else {
            add({
                endpoints: endpoints.customer.api,
                onSuccess: (data: any) => {
                    setPage('two')
                    navigate({
                        pathname: `${data.data}`,
                    })
                    setIsSubmitting(false)
                    toast.success(data.message, { style: { background: '#3150A1' } })
                },
                onError: (error: any) => {
                    toast.error(error.message ?? error)
                    setIsSubmitting(false)
                },
                values: values
            })
        }
    }

    const clearForm = () => {
        setValue('firstName', "")
        setValue('middleName', "")
        setValue('lastName', "")
        setValue('mobileNumber', "")
        setValue('email', "")
        setValue('dob', "")
        setValue('docType', null)
        setValue('docId', "")
        setValue('othersDocName', "")
        setValue('docPhotoUrl', "")
        setValue('permanentAddress', "")
        setValue('temporaryAddress', "")
        setValue('fatherName', "")
        setValue('motherName', "")
        setValue('spouseName', "")
        setValue('applicationNumber', "")
        setValue('passcode', "")
        setValue('profileImage', "")
        setValue('accountType', null)
        setValue('heldAmount', 0)
        setValue('availableBalance', 0)
        setValue('isStaff', false)
        setValue('branchCode', "")
        setValue('isBlocked', '')
    }

    const setData = (data: any) => {
        setValue('firstName', data.data.firstName)
        setValue('middleName', data.data.middleName)
        setValue('lastName', data.data.lastName)
        setValue('mobileNumber', data.data.mobileNumber)
        setValue('email', data.data.email)
        setValue('dob', data.data.dob)
        setValue('docType', data.data.docType)
        setValue('docId', data.data.docId)
        setValue('othersDocName', data.data.othersDocName)
        setValue('docPhotoUrl', data.data.docPhotoUrl)
        setValue('permanentAddress', data.data.permanentAddress)
        setValue('temporaryAddress', data.data.temporaryAddress)
        setValue('fatherName', data.data.fatherName)
        setValue('motherName', data.data.motherName)
        setValue('spouseName', data.data.spouseName)
        setValue('applicationNumber', data.data.applicationNumber)
        setValue('passcode', data.data.passcode)
        setValue('profileImage', data.data.profileImage)
        setValue('accountType', data.data.accountType)
        setValue('heldAmount', data.data.heldAmount)
        setValue('availableBalance', data.data.availableBalance)
        setValue('isStaff', data.data.isStaff)
        setValue('branchCode', data.data.branchCode)
        setValue('isBlocked', data.data.isBlocked)
    }

    const fetchFromAccountNo = (accountNumber: string) => {
        setIsLoading(true)
        get({
            endpoints: endpoints.customer.getCustomerByAccountNo(accountNumber),
            onSuccess: (data: any) => {
                if (data.data) {
                    setIsData(true)
                    setData(data)
                } else {
                    setIsData(false)
                    clearForm()
                    toast.error(data?.message ?? data)
                }
                setIsLoading(false)
            },
            onError: (error: any) => {
                setIsData(false)
                setIsLoading(false)
                clearForm()
                toast.error(error ?? '')
            }
        })
    }

    const accountType = Object.keys(AccountTypes)
        .filter((value => isNaN(Number(value)) === false))
        .map((key: any) => ({ value: Number(key), label: AccountTypes[key] }));
    const documentType = Object.keys(DocumentTypes)
        .filter((value => isNaN(Number(value)) === false))
        .map((key: any) => ({ value: Number(key), label: DocumentTypes[key] }));

    useEffect(() => {
        if (watchAccountNumber && !selectedCustomer) {
            if (isData) {
                fetchFromAccountNo(watchAccountNumber)
            }
        }
    }, [watchAccountNumber])

    useEffect(() => {
        setConfirmEdit(isAttorney || isJoint || (id ? true : false))
    }, [isAttorney, isJoint, id])

    return (
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
            <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700", }} mb={4}>
                Personal Information
            </Typography>

            <Grid sx={{ flexGrow: 1 }} container spacing={2}>
                <Grid item xs={8}>
                    <Grid container spacing={2} sx={{ maxHeight: '200px' }}>
                        <Grid item xs={4} >
                            <CustomSelect
                                disabled={true}
                                label="Account Type"
                                name="accountType"
                                errors={errors?.accountType?.message}
                                control={control}
                                values={accountType ?? []}
                                size={12}
                                isEnum={true}
                            />
                        </Grid>
                        <Grid item xs={8} >
                            <Box sx={{ position: 'relative', width: 'fit' }}>
                                <form>
                                    <ControlledInput name="accountNumber" control={control} errors={errors} label="Acccount No."
                                        disabled={confirmEdit} />
                                    <button type="submit" style={{ border: 'none', background: 'none', position: 'absolute', top: '10px', right: '10px', width: 'fit-content', cursor: 'pointer' }} onClick={(e) => {
                                        e.preventDefault();
                                        if (!selectedCustomer?.accountNumber) {
                                            fetchFromAccountNo(watchAccountNumber)
                                        }
                                    }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px' }} >
                                            {
                                                confirmEdit ? <Edit onClick={() => setConfirmDialog(true)} /> : null
                                            }
                                            {
                                                isLoading ? <Refresh sx={{
                                                    animation: 'spin 1s linear infinite',
                                                    '@keyframes spin': {
                                                        from: {
                                                            transform: 'rotate(0deg)'
                                                        },
                                                        to: {
                                                            transform: 'rotate(360deg)'
                                                        }
                                                    }
                                                }} /> : <Search />
                                            }
                                        </Box>
                                    </button>
                                </form>
                            </Box>
                        </Grid>
                        <Grid item xs={4}>
                            <ControlledInput name="firstName" disabled={!isData} control={control} errors={errors} label="First Name" />
                        </Grid>
                        <Grid item xs={4}>
                            <ControlledInput name="middleName" disabled={!isData} control={control} errors={errors} label="Middle name" />
                        </Grid>
                        <Grid item xs={4}>
                            <ControlledInput name="lastName" disabled={!isData} control={control} errors={errors} label="Last name" />
                        </Grid>
                        <Grid item xs={4}>
                            <ControlledInput type="number" name="mobileNumber" disabled={!isData} control={control} errors={errors} label="Mobile No." />
                        </Grid>
                        <Grid item xs={4}>
                            <ControlledInput name="email" disabled={!isData} control={control} errors={errors} label="Email" />
                        </Grid>
                        <Grid item xs={4}>
                            <ControlledInput name="dob" type="date" disabled={!isData} control={control} errors={errors} label="Date of Birth" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={4}>
                    <Grid container spacing={2} >
                        <Grid item xs={12}>

                            <CameraCapture setImageUrl={setProfileImageUrl} imageUrl={profileImageUrl ?? getValues()?.profileImage} setValue={setValue} name={'profileImage'} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700" }} my={2}>
                Document Information
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={4} >
                    <CustomSelect
                        label="Document Type"
                        name="docType"
                        errors={errors?.docType?.message}
                        control={control}
                        values={documentType ?? []}
                        size={12}
                        isEnum={true}
                        disabled={!isData}
                        height='40px'
                    />
                </Grid>
                <Grid item xs={4}>
                    <ControlledInput name="docId" disabled={!isData} control={control} errors={errors} label={(watchAccountDocumentType && watchAccountDocumentType !== '') || watchAccountDocumentType === 0 ? DocumentTypes[watchAccountDocumentType] + ' Number' : "Document Number"} />
                </Grid>

                {formData.docType !== 5
                    ?
                    <Grid item xs={6}>
                        <Typography sx={{ color: "black", fontSize: "14px", fontWeight: "400", marginBottom: '4px' }} >
                            Upload  {DocumentTypes[watchAccountDocumentType]}
                        </Typography>
                        {<FileUpload
                            setValue={setValue}
                            label="Document Type"
                            name="docPhotoUrl"
                            errors={errors} control={control}
                            getValues={getValues}
                            size={12}
                            setImageUrl={setImageUrl}
                            imageUrl={imageUrl ?? getValues('docPhotoUrl')}
                        />
                        }
                    </Grid>
                    :
                    <Grid item xs={12} >
                        <ControlledTextArea name="othersDocName" disabled={!isData} control={control} errors={errors} label="Description" />
                    </Grid>}
            </Grid>

            <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700" }} my={2}>
                Address Information
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <ControlledInput name="temporaryAddress" disabled={!isData} control={control} errors={errors} label="Temporary Address" />
                </Grid>
                <Grid item xs={4}>
                    <ControlledInput name="permanentAddress" disabled={!isData} control={control} errors={errors} label="Permanent Address" />
                </Grid>
            </Grid>

            <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700" }} my={2}>
                Family Information
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <ControlledInput name="fatherName" disabled={!isData} control={control} errors={errors} label="Father's Name" />
                </Grid>
                <Grid item xs={4}>
                    <ControlledInput name="motherName" disabled={!isData} control={control} errors={errors} label="Mother's Name" />
                </Grid>
                <Grid item xs={4}>
                    <ControlledInput name="spouseName" disabled={!isData} control={control} errors={errors} label="Spouse Name" />
                </Grid>
            </Grid>
            <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700" }} my={2}>
                Additional Information
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <Typography sx={{ color: "black", fontSize: "14px", fontWeight: "400", marginBottom: '4px', marginLeft: '4px' }} >
                        Is Staff ?
                    </Typography>
                    <Switch disabled={!isData} checked={watchIsStaff} onChange={() => setValue('isStaff', !watchIsStaff)} />
                </Grid>
            </Grid>
            <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700" }} my={2}>
                Locker Security
            </Typography>
            <Grid container spacing={2} >
                <Grid item xs={4}>
                    <ControlledInput name="applicationNumber" disabled={isAttorney || isJoint} control={control} errors={errors} label="Application Number" />
                </Grid>
                <Grid item xs={4}>
                    {
                        !isAttorney && !isJoint ?
                            <ControlledInput type="password" name="passcode" disabled={!isData} control={control} errors={errors} label="Passcode" />
                            : null
                    }
                </Grid>
            </Grid>
            {/* </>
            } */}
            <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700" }} my={2}>
                Locker Details
            </Typography>
            <Grid container spacing={2} >
                <Grid sx={{ width: "100%", border: 'solid 1px #9e9e9e', marginLeft: '16px', borderRadius: '4px', mt: '12px' }}>
                    <LockerTable isJoint={isJoint} isAttorney={isAttorney} getValues={getValues} setValue={setValue} watch={watch} append={append} remove={remove} update={update} options={lockerType} errors={errors} rows={fields} control={control} />
                    {errors.customerLockers && <Typography mt={1} ml={2} sx={{ color: "#DD2F30", fontSize: "12px" }}>{errors.customerLockers.message}</Typography>}
                    {!isAttorney && !isJoint && selectedCustomer?.accountType !== 2 ? <Button style={{ marginTop: '4px', marginLeft: '16px', fontSize: '12px' }}
                        onClick={() => append({ lockerTypeId: null, lockerId: null, discount: null })}
                    > Add Lockers</Button> : null}
                </Grid>
            </Grid>
            <FooterInfo isEdit={selectedCustomer && id ? true : false} loading={submitting} />
            <AccountNoEditDialog onSuccess={() => {
                setConfirmEdit(false)
                setConfirmDialog(false)
            }} onError={() => {
                setConfirmEdit(true)
                setConfirmDialog(false)
            }} openAlertModal={confirmDialog} />
        </Box >
    )
}

export default DetailsForm;

const initialValues = {
    accountNumber: '',
    firstName: '',
    middleName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    dob: '',
    docType: null,
    docId: '',
    othersDocName: '',
    docPhotoUrl: '',
    permanentAddress: '',
    temporaryAddress: '',
    fatherName: '',
    motherName: '',
    spouseName: '',
    applicationNumber: '',
    passcode: '',
    accountType: null,
    customerLockers: [{
        discount: 0
    }],
    profileImage: '',
    heldAmount: 0,
    availableBalance: 0,
    isStaff: false,
    branchCode: '',
    isBlocked: '',
}

export type valuesTypes = {
    id: number | null,
    accountNumber: string,
    firstName: string,
    middleName: string,
    lastName: string,
    mobileNumber: string,
    email: string,
    dob: string,
    docType: number | null,
    docId: string,
    othersDocName: string,
    docPhotoUrl: string,
    permanentAddress: string,
    temporaryAddress: string,
    fatherName: string,
    motherName: string,
    spouseName: string,
    applicationNumber: string,
    passcode: string,
    accountType: number | null,
    customerLockers: { lockerTypeId: number | null, lockerId: number | null, discount: number | null }[],
    profileImage: string,
    isApproved: boolean,
    heldAmount: 0,
    availableBalance: 0,
    isStaff: boolean,
    branchCode: '',
    isBlocked: '',
    createdUsername: string,
    createdDate: string | null,
    updatedUsername: string,
    updatedDate: string | null,
    verifiedUsername: string,
    verifiedDate: string | null,
}

export const customerRegisterValidation = Yup.object().shape({
    accountNumber: Yup.string().required("Required"),
    firstName: Yup.string().required(" Required"),
    lastName: Yup.string().required(" Required"),
    mobileNumber: Yup.string().required(" Required"),
    email: Yup.string().email().nullable(),
    dob: Yup.string().required(" Required"),
    docType: Yup.number().required(" Required").typeError('Required'),
    docId: Yup.string().required(" Required"),
    permanentAddress: Yup.string().required(" Required"),
    temporaryAddress: Yup.string().required(" Required"),
    fatherName: Yup.string().required(" Required"),
    motherName: Yup.string().required(" Required"),
    passcode: Yup.string().test('passcode Required', 'Required', function (value) {
        if (!this.parent?.id) {
            return this.parent.passcode !== '';
        }
        return true;
    }),
    accountType: Yup.number().required(" Required").typeError('Required'),
    customerLockers: Yup.array()
        .of(
            Yup.object().shape({
                lockerTypeId: Yup.number().required(" Required").typeError('Required'),
                discountType: Yup.number().required(" Required").typeError('Required'),
                discount: Yup.number().required(" Required").typeError('Required'),
                // lockerId: Yup.number().required(" Required").typeError('Required'),
            })
        )
        .min(1, 'required at least one locker'),
});

export const LockerTable = ({ isJoint, isAttorney, getValues, setValue, rows, options, errors, control, remove, append, update, watch }: { isJoint: any, isAttorney: any, getValues: any, setValue: any, watch: any, append: any, remove: any, update: any, errors: any, control: any, rows: any, options: any }) => {
    const { id } = useParams()
    const [isReleaseModalOpen, setIsReleaseModalOpen] = useState(false)
    const [selectedItem, setSelectedItem] = useState<any | null>(null)

    const onChangeLockertype = (e: any, index: any) => {
        const watchLockerType = watch(`customerLockers.${index}.lockerTypeId`)
        if (e.value !== watchLockerType) {
            setValue(`customerLockers.${index}.lockerId`, 0)
        }
    }

    return <>
        <Table sx={{ width: "100%" }} aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableHeadCell minwidth='5%'>S.N</TableHeadCell>
                    <TableHeadCell align="left" minwidth='10%'>Locker Type </TableHeadCell>
                    <TableHeadCell align="left" minwidth='13%'>Locker </TableHeadCell>
                    <TableHeadCell align="left" minwidth='15%'>Discount Type</TableHeadCell>
                    <TableHeadCell align="left" minwidth='10%'>Discount(%)</TableHeadCell>
                    <TableHeadCell align="left" minwidth='10%'>Status </TableHeadCell>
                    <TableHeadCell align="center" minwidth='18%'>Action </TableHeadCell>
                    <TableHeadCell align="center" minwidth='19%'>Remarks </TableHeadCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row: any, index: number) => {
                    return (
                        <TableRow key={row.id}>
                            <TableCell align="center" sx={{ padding: '4px 4px', }}>
                                {index + 1}
                            </TableCell>
                            <TableCell sx={{ padding: '4px 4px', width: '200px' }} >
                                <CustomSelect
                                    onHandleChnage={onChangeLockertype}
                                    disabled={isAttorney || isJoint || row.isVerified}
                                    name={`customerLockers.${index}.lockerTypeId`}
                                    errors={errors?.customerLockers?.[index]?.lockerTypeId?.message}
                                    control={control}
                                    values={options ?? []}
                                    size={12}
                                    height='40'
                                    index={index}
                                />
                            </TableCell>
                            <LockersNumber isJoint={isJoint} isAttorney={isAttorney} getValues={getValues} index={index} errors={errors} control={control} watch={watch} setValue={setValue} />

                            <TableCell sx={{ padding: '4px 4px' }}>
                                {id || (getValues().customerLockers[index]?.lockerstatus || getValues().customerLockers[index]?.lockerstatus === 0)
                                    ?
                                    <Box sx={{ display: 'flex', gap: '2px' }}>
                                        {getValues().customerLockers[index].lockerstatus === 2
                                            ? <>
                                                <Button
                                                    sx={{ fontSize: '12px' }}
                                                    disabled={isAttorney || isJoint}
                                                    onClick={() => {
                                                        setIsReleaseModalOpen(true)
                                                        setSelectedItem({ ...getValues().customerLockers[index], itemIndex: index })
                                                    }}
                                                > Release</Button>
                                                <Button
                                                    sx={{ fontSize: '12px' }}
                                                    disabled={isAttorney || isJoint}
                                                    onClick={() => setValue(`customerLockers.${index}.lockerstatus`, 3)}
                                                > Block</Button>
                                            </>
                                            : getValues().customerLockers[index].lockerstatus === 3 ? <>
                                                <Button
                                                    disabled={isAttorney || isJoint}
                                                    onClick={() => {
                                                        setIsReleaseModalOpen(true)
                                                        setSelectedItem({ ...getValues().customerLockers[index], itemIndex: index })
                                                    }}
                                                > Release</Button>
                                                <Button
                                                    disabled={isAttorney || isJoint}
                                                    onClick={() => {
                                                        setValue(`customerLockers.${index}.lockerstatus`, 2)
                                                        setValue(`customerLockers.${index}.remarks`, '')
                                                    }}
                                                > Occupied</Button>
                                            </> : getValues().customerLockers[index].lockerstatus === 1 ? <Button
                                                disabled={isAttorney || isJoint}
                                                onClick={() => {
                                                    setValue(`customerLockers.${index}.lockerstatus`, 0)
                                                }}
                                            > Release</Button> : null
                                        }
                                    </Box>
                                    : null
                                }{(!row.lockerId || !getValues().customerLockers[index]?.id) && row?.isVerified === undefined
                                    ? <Button onClick={() => remove(index)}  >
                                        Delete
                                    </Button>
                                    : null
                                }
                            </TableCell>
                            <TableCell sx={{ padding: '4px 4px' }}>
                                <ControlledTextArea name={`customerLockers.${index}.remarks`} control={control} errors={errors} label="" rows={2} disabled={isAttorney || isJoint} />
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
        <AddEditModal title={`Locker (${selectedItem?.lockerNumber}) Release Detail`} setOpen={setIsReleaseModalOpen} setSelectedItem={setSelectedItem} open={isReleaseModalOpen}>
            <CustomerLockerReleaseForm selectedItem={selectedItem} setSelectedItem={setSelectedItem} setOpen={setIsReleaseModalOpen} setMainValue={setValue} />
        </AddEditModal>
    </>
}

const LockersNumber = ({ isJoint, isAttorney, getValues, index, errors, control, watch, setValue }: { isJoint: any, isAttorney: any, getValues: any, index: number, errors: any, control: any, watch: any, setValue: any }) => {

    const watchLockerType = watch(`customerLockers.${index}.lockerTypeId`)
    const watchLocker = watch(`customerLockers.${index}.lockerId`)
    const watchLockerStatus = watch(`customerLockers.${index}.lockerstatus`)
    const watchIsVerified = watch(`customerLockers.${index}.isVerified`)
    const [lockerList, setLockerList] = useState([])
    const [discountTypeList, setDiscountTypeList] = useState([])

    const { get } = useCrudForm()

    useEffect(() => {
        if (watchLockerType) {
            get({
                endpoints: endpoints.common.getLockersByLockerTypeId(watchLockerType),
                onSuccess: (data: any) => {
                    const filteredData = data?.data.filter((locker: any) => !getValues().customerLockers.some((loc: any) => loc.lockerId === locker.id))
                    const selectedLocker = (watchLocker && watchLocker !== 0) ?
                        getValues().customerLockers.filter((locker: any) => locker.lockerId === watchLocker).map((loc: any) => {
                            return { id: loc.lockerId, name: loc.lockerNumber }
                        }) : filteredData
                    setLockerList(selectedLocker)
                },
                onError: (error: any) => {
                    console.log(error)
                }
            })

            get({
                endpoints: endpoints.common.getDiscountTypes,
                onSuccess: (data: any) => {
                    setDiscountTypeList(data.data)
                },
                onError: (error: any) => {
                    console.log(error)
                }
            })

        }
    }, [watchLockerType])

    return <>
        <TableCell sx={{ padding: '4px 4px', width: '280px' }}>
            <CustomSelect
                disabled={isAttorney || isJoint || watchIsVerified}
                name={`customerLockers.${index}.lockerId`}
                errors={errors?.customerLockers?.[index]?.lockerId?.message}
                control={control}
                values={lockerList ?? []}
                size={12}
                height='40'
            />
        </TableCell>
        <TableCell sx={{ padding: '4px 4px', width: '280px' }}>
            <CustomSelect
                disabled={isAttorney || isJoint || watchIsVerified}
                name={`customerLockers.${index}.discountType`}
                errors={errors?.customerLockers?.[index]?.discountType?.message}
                control={control}
                values={discountTypeList ?? []}
                size={12}
                height='40'
            />
        </TableCell>
        <TableCell sx={{ padding: '4px 4px', width: '120px' }}>
            <ControlledInput name={`customerLockers.${index}.discount`} disabled={isAttorney || isJoint || watchIsVerified} control={control} errors={errors} discountErrors={errors?.customerLockers?.[index]?.discount?.message} type="number" height="2rem" />
        </TableCell>
        <TableCell sx={{ padding: '4px 4px', width: '200px' }} >
            <Box sx={{ background: getStatusColor(watchLockerStatus), borderRadius: "6px", padding: '6px 12px' }}>
                <Typography sx={{ color: "white", fontWeight: '500', fontSize: '14px' }}>
                    {watchLockerStatus ? LockerStatus[watchLockerStatus] : watchLocker ? 'Available' : 'N/A'}
                </Typography>
            </Box>
        </TableCell>
    </>
}

export const getStatusColor = (watchLockerStatus: number) => {
    if (watchLockerStatus === 0) {
        return "green"
    } else if (watchLockerStatus === 1) {
        return "blue"
    } else if (watchLockerStatus === 2) {
        return 'red'
    } else if (watchLockerStatus === 3) {
        return 'gold'
    } else if (watchLockerStatus === 4) {
        return 'orange'
    } else if (watchLockerStatus === 5) {
        return 'gray'
    } else if (watchLockerStatus === 6) {
        return 'brown'
    } else if (watchLockerStatus === 7) {
        return 'purple'
    } else if (watchLockerStatus === 8) {
        return 'cyan'
    } else {
        return 'black'
    }
}

export const AccountNoEditDialog = ({ openAlertModal, onSuccess, onError }: { onSuccess: () => void, onError: () => void, openAlertModal: boolean }) => {

    return <Modal
        open={openAlertModal}
        onClose={onError}
    >
        <Box sx={{ ...SaveStyle, width: 200, textAlign: 'center' }}>
            <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                <NotificationImportantIcon sx={{ width: '60px', height: '60px', color: 'red' }} />
                <Typography sx={{ margin: '0 0px 10px', padding: '0px' }}>{'Are you sure want to edit this account number?'}</Typography>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <Button onClick={() => onSuccess()} variant='contained' sx={{ backgroundColor: '#3150A1', color: 'white', width: '50%' }}>Confirm</Button>
                    <Button onClick={() => onError()} variant='contained' sx={{ backgroundColor: 'red', color: 'white', width: '50%' }} color="error" > Cancel</Button>
                </Box>
            </Stack>
        </Box >
    </Modal >
}